export const Map = {
    OfferInformationEmail: 'send-information-email',
    Greeting: 'greeting',
    QualifyLead: 'qualify-lead',
    ChooseDojo: 'dojo',
    Interest: 'interest',
    InterestTimeline: 'interest-timeline',
    FamilyTraining: 'family-training',
    HowCanWeHelp: 'how-can-we-help',
    PresentOffer: 'present-offer',
    YourGoals: 'your-goal',
    ForWomen: 'for-women',
    YourDojo: 'your-dojo',
    Close: 'close',
}